import { createFileRoute } from '@tanstack/react-router';
import { CarrierActivityTab } from '@/features/carriers/detail/activity-tab';

// The carrier's diary: its lines of the activity stream (S17 has the whole stream).
export const Route = createFileRoute('/_app/carriers/$code/activity')({
  component: CarrierActivityTab,
});
